import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import * as m from '@/paraglide/messages.js';

import { JobOfferDetailContent } from './-components/JobOfferDetailContent';
import { jobOffersApi } from './-components/jobOffersApi';

export const Route = createFileRoute('/{-$locale}/job-offers/')({
  // loaderDeps: ({ search }) => ({ search }),
  // loader: async ({ context, deps: { search } }) => {
  //   console.log('search2', search);
  //   const { data: jobOffers } = await context.queryClient.ensureQueryData(jobOffersApi.list.queryOptions(search));
  //   console.log('jobOffers2', jobOffers);
  //   const defaultJobOfferId = jobOffers.length > 0 ? jobOffers[0].id : null;
  //   if (defaultJobOfferId) {
  //     await context.queryClient.ensureQueryData(jobOffersApi.detail.queryOptions(defaultJobOfferId));
  //   }
  //   return { defaultJobOfferId };
  // },
  component: RightPanel,
  errorComponent: ErrorComponent,
  pendingComponent: () => <LoadingSpinner message={m.loading_offer()} />,
});

function RightPanel() {
  const search = Route.useSearch();
  const { data: jobOffers } = jobOffersApi.useList(search);
  const { data: jobOfferDefault } = jobOffersApi.useDetail(jobOffers.data[0]?.id ?? '');
  // const { defaultJobOfferId } = Route.useLoaderData();

  // if (!defaultJobOfferId) return (null);
  return <JobOfferDetailContent offer={jobOfferDefault} />;
  // return <div>Select a job offer</div>
}

// function JobOffersIndexPage({ defaultJobOfferId }: { defaultJobOfferId: string }) {

//   const { data: jobOfferDefault } = jobOffersApi.useDetail(defaultJobOfferId);
//   console.log('jobOfferDefault', jobOfferDefault);

//   const isDesktop = useMediaQuery('(min-width: 1024px)');
//   if (!isDesktop) return null;

//   return <JobOfferDetailContent offer={jobOfferDefault} />;
// }
